import HTTPClient from '../HTTPClient';

const SsoApiClient = new HTTPClient({
  baseURL: process.env.REACT_APP_SSO_API_URL as string,
  withCredentials: true,
});

export default SsoApiClient;
